import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox"]

  connect() {
  }

  toggle(event) {
    const clicked = event.currentTarget

    if (clicked.checked) {

      const handler = () => {
        this.checkboxTargets.forEach(elem => {
          elem.checked = false
        })
        window.removeEventListener("click", handler);
      }

      window.addEventListener("click", handler)

      this.checkboxTargets.forEach(other => {
        if (other !== clicked) {
          other.checked = false
        }
      })
    }
  }
}
